const menuItems = [
  { name: 'Home', icon: null, url: '/dashboard' },
  { name: 'Sales', icon: null, url: '/dashboard/sales' },
  { name: 'Reports', icon: null, url: '/dashboard/reports' },
  { name: 'Products', icon: null, url: '/dashboard/products' },
  { name: 'Customers', icon: null, url: '/dashboard/customers' },
  { name: 'Manufacturers', icon: null, url: '/dashboard/Manufacturers' },
  { name: 'Weight Units', icon: null, url: '/dashboard/weight-units' },
  /* { name: 'Categories', icon: null, url: '/dashboard/categories' },*/
];

export default menuItems;
